import pageUrls from 'constants/pagesUrls';

import type {
  ProfileType,
  SubscriptionNamesType,
} from 'redux-store/slices/profile/types';

const redirectsUrl: Record<SubscriptionNamesType, string> = {
  Monthly: pageUrls.offer('annualOrLifetimeOffer'),
  Free: pageUrls.offer('mobileAppAndFreeUserOffer'),
  Yearly: pageUrls.offer('annualOrLifetimeOffer'),
  Annual: pageUrls.offer('2yearsAndLifetimeOffer'),
  '2 years': pageUrls.offer(),
  Lifetime: pageUrls.offer(),
  PRO: pageUrls.offer(),
  '': pageUrls.offer(),
};

export default function getAuthRedirectUrl(profile?: ProfileType): string {
  const subscriptionName = profile?.subscription_name?.en || '';

  return redirectsUrl[subscriptionName];
}
